var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00079 13.0202C5.00594 13.076 5.02139 13.1316 5.04713 13.1823C6.45931 16.0365 9.48983 18 12.9998 18C16.5044 18 19.5452 16.0365 20.9574 13.1823C21.0142 13.0658 21.0142 12.9242 20.9574 12.8077C19.5452 9.96368 16.5044 8 12.9998 8C9.49498 8 6.45931 9.96368 5.04713 12.8077C5.01624 12.8737 4.99564 12.9444 5.00079 13.0202ZM5.94384 12.9951C7.24788 10.5455 9.90728 8.86051 12.9998 8.86051C16.0919 8.86051 18.7566 10.5457 20.0607 12.9951C18.7566 15.4496 16.0921 17.1448 12.9998 17.1448C9.90214 17.1448 7.24788 15.4496 5.94384 12.9951ZM10.0928 13.0051C10.0928 14.5789 11.3967 15.8593 12.9998 15.8593C14.6025 15.8593 15.9065 14.5789 15.9065 13.0051C15.9065 11.4311 14.6025 10.1458 12.9998 10.1458C11.3967 10.1458 10.0928 11.4311 10.0928 13.0051ZM10.9691 13.0051C10.9691 11.8966 11.871 11.0011 12.9998 11.0011C14.1284 11.0011 15.0354 11.8968 15.0354 13.0051C15.0354 14.1134 14.1282 14.9991 12.9998 14.9991C11.871 14.9991 10.9691 14.1134 10.9691 13.0051Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show-password.5a2711c9.svg";
export { ForwardRef as ReactComponent };